module.exports = __webpack_public_path__ + "static/media/male1.498a795b.png";